import axios from 'utils/axios'

export const dragAndDropTasksInTodaySection = (body) => {
  let endpoint = `/today-view/tasks/drag-and-drop/today`
  return axios.post(endpoint, body)
}
